/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetUploadUrlResponse interface.
 */
export function instanceOfGetUploadUrlResponse(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('key' in value) || value['key'] === undefined)
        return false;
    return true;
}
export function GetUploadUrlResponseFromJSON(json) {
    return GetUploadUrlResponseFromJSONTyped(json, false);
}
export function GetUploadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'key': json['key'],
    };
}
export function GetUploadUrlResponseToJSON(json) {
    return GetUploadUrlResponseToJSONTyped(json, false);
}
export function GetUploadUrlResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'key': value['key'],
    };
}
